import { add } from 'date-fns'
import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useState,
} from 'react'
import { Location } from '../lib/hooks/api'

export type InputContext = {
  reportDate: number
  startDate: number | null
  endDate: number | null
  location: Location | null
  interval: 'day' | 'hour'
}
//useGetVisits(values.startDate, values.endDate, values.location, ((!!values.startDate && !!values.endDate) && !!values.location) && values.startDate < values.endDate)

const initialContext: InputContext = {
  reportDate: new Date(
    add(Date.UTC(new Date().getUTCFullYear(), new Date().getUTCMonth(), 1), {
      months: -1,
    }),
  ).getTime(),
  startDate: new Date(
    add(
      Date.UTC(
        new Date().getUTCFullYear(),
        new Date().getUTCMonth(),
        new Date().getUTCDate(),
      ),
      { days: -7 },
    ),
  ).getTime(),
  endDate: Date.UTC(
    new Date().getUTCFullYear(),
    new Date().getUTCMonth(),
    new Date().getUTCDate(),
  ),
  location: null,
  interval: 'day',
}

export const inputContext = createContext<{
  values: InputContext
  setValues: Dispatch<SetStateAction<InputContext>>
}>({
  values: initialContext,
  setValues: () => undefined,
})

const InputContextProvider = ({ children }: { children: ReactNode }) => {
  const [values, setValues] = useState<InputContext>(initialContext)
  return (
    <inputContext.Provider value={{ values, setValues }}>
      {children}
    </inputContext.Provider>
  )
}

export default InputContextProvider
